import React, { useState, useEffect } from 'react';
import './notificationCenter.css';
import { useTranslation } from "react-i18next";
import UserUtilityBar from './UserUtilityBar';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateUserNotificationsServiceInit } from '../../../../store/Notifications/UpdateNotification/UpdateNotificationSlice';
import Loader from '../../../shared/loader/Loader';
import { GetUserNotificationsServiceInit } from '../../../../store/Notifications/UserNotificationSlice';

export const NOTIFICATION_TYPE = { 'READ': 'READ', 'UNREAD': 'UNREAD' };

const NotificationList = (props) => {

    const { t } = useTranslation(["translation"]);

    const {
    notificationList,
    notificationType
  } = props;

  const [expandedMessageId, setExpandedMessageId] = useState(null);
  const dispatch = useDispatch();
  const [dispatchedMsgIds, setDispatchedMsgIds] = useState(new Set());

  const toggleMessage = (id) => {
    setExpandedMessageId(prevId => (prevId === id ? null : id));
  };
  
  const notificationClicked = (msgId) => {
    if (dispatchedMsgIds.has(msgId)) return;
    setDispatchedMsgIds(prev => new Set(prev).add(msgId));
    dispatch(UpdateUserNotificationsServiceInit(msgId));
  };

  return (
    <>
      {
        notificationList.length > 0 && (
          <div className="notification-section">
            <h2>{(notificationType === NOTIFICATION_TYPE.UNREAD) ? 'Unread' : 'Read'}</h2>
            <ul className="notification-list">
              {notificationList.map((notification) => (
                <li key={notification.messageId}
                  className={`notification-item ${(notificationType === NOTIFICATION_TYPE.UNREAD) ? 'new' : 'read'}`}
                  onClick={((notificationType === NOTIFICATION_TYPE.UNREAD) ? () => notificationClicked(notification.messageId) : undefined)}>
                  <div className="notification-firstline">
                    {
                      (notificationType === NOTIFICATION_TYPE.UNREAD && !notification.isRead
                        && !dispatchedMsgIds.has(notification.messageId)) && <div className='dot-box'><span className="unread-indicator"></span></div>
                    }
                          <div><h3>{notification.messageTitle}</h3></div>
                  </div>
                  <p>
                    {
                      expandedMessageId === notification.messageId
                        ? notification.message
                        : notification.message.substring(0, 150) + (notification.message.length > 150 ? '... ' : '')
                    }
                    {
                      notification.message.length > 150 && (
                        <span
                          onClick={() => toggleMessage(notification.messageId)}
                          className='show-full-message'
                        >
                                      {expandedMessageId === notification.messageId
                                          ? t('BROTHER_PLUS.NOTIFICATIONS.SHOW_LESS')
                                          : t('BROTHER_PLUS.NOTIFICATIONS.SHOW_MORE')}
                        </span>
                      )
                    }
                    {
                              <span><br/><br/></span>
                    }
                     {notification.accessUrl && (
                      <a href={notification.accessUrl} target='_blank' rel="noreferrer" >
                                  {notification.accessUrlTitle || t('BROTHER_PLUS.NOTIFICATIONS.FIND_OUT_MORE')}
                      </a>
                    )} 
                  </p>
                </li>
              ))}
            </ul>
          </div>
        )
      }
    </>
  )
}

const NotificationCenter = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["translation"]);
  const {
    loading: notificationListLoading,
    success: notificationListSuccess,
    data: notificationList
  } = useSelector((state => state.ROOTREDUCER_RTK.GetUserNotificationService));

  const [readNotifications, setReadNotifications] = useState([]);
  const [unReadNotifications, setUnReadNotifications] = useState([]);

  useEffect(() => {
    dispatch(GetUserNotificationsServiceInit(0))
  }, [dispatch]);

  useEffect(() => {
    if (notificationListSuccess) {
      setReadNotifications(notificationList?.readNotifications);
      setUnReadNotifications(notificationList?.unreadNotifications);
    }
  }, [notificationListSuccess, notificationList]);
  return (
    <div className="notification-center">
      <div className="notification-header">
        <div>
          <h1>{t('BROTHER_PLUS.NOTIFICATIONS.NOTIFICATION_CENTER')}</h1>
          <p>{t('BROTHER_PLUS.NOTIFICATIONS.SUB_HEADER')}</p>
        </div>
        <div>
          <UserUtilityBar />
        </div>
      </div>
      {
        notificationListLoading ? <Loader /> :
          <>
            {
              (unReadNotifications.length === 0 && readNotifications.length === 0)
              && <p class="mt-40 info-error-message">{t('BROTHER_PLUS.NOTIFICATIONS.NO_NOTIFICATION')}</p>
            }
            <NotificationList
              notificationList={unReadNotifications}
              notificationType={NOTIFICATION_TYPE.UNREAD}
            />
            <NotificationList
              notificationList={readNotifications}
              notificationType={NOTIFICATION_TYPE.READ}
              setReadNotifications={setReadNotifications}
            />
          </>
      }

    </div>
  );
};

export default NotificationCenter;